import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {DataTableDirective} from 'angular-datatables';
import {forkJoin, of, Subject} from 'rxjs';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../../../environments/environment';
import {CommissionPromoterAdditional} from '../../../model/commission-promoter-additional';
import {CommissionPromoterAdditionalService} from '../../../services/commission-promoter-additional.service';
import {ModalCommissionPromoterAdditionalComponent} from '../../../shared/modal-commission-promoter-additional/modal-commission-promoter-additional.component';
import {CatEmployeeJobService} from '../../../../app/services/cat-employee-job.service';
import {CatalogModel} from '../../../../app/model/other-catalogs-models';
import {catchError, tap} from 'rxjs/operators';
import {ModalConfirmComponent} from '../../../shared/modal-confirm/modal-confirm.component';

@Component({
  selector: 'app-commission-promoter-additional',
  templateUrl: './commission-promoter-additional.component.html',
  styleUrls: ['./commission-promoter-additional.component.css']
})
export class CommissionPromoterAdditionalComponent implements OnInit, AfterViewInit  {

  // STATE
  public page='CommissionPromoterAdditional';
  public viewStatus:number=0;
  public loading:number=0;
  public listCommissionPromoter:CommissionPromoterAdditional[]=[];
  public listCommissionPromoterFiltered:CommissionPromoterAdditional[]=[];
  public selectedEmployeeJob:number[]=[];
  public errors:number;
  public hidden:boolean=true;
  public activeCommissions:boolean=false;

  // CATALOGS
  public employeeJobsCatalog:CatalogModel[]=[];
  public selectedEmployeeJobs:any[]=[];
  public selectedEmployeeJobsDD:string[]=[];

  // DATATABLE
  @ViewChild(DataTableDirective, {static: false})
  private datatableElement: DataTableDirective;
  public url:string;
  public columns:any[]=[];

  // DATATABLE OPTIONS
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any = {};

  constructor(
    private commissionPromoterAdditionalService:CommissionPromoterAdditionalService,
    private catEmployeeJobService:CatEmployeeJobService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) {
    this.url=environment.services_url;
  }

  ngOnInit() {
    this.dtOptions={
      order:[],
      responsive: true,
      select: 'single',
      bLengthChange: true,
      searching :true,
      dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
      buttons: ['csv', 'excel'],
      // dom: 'Bfrtip',
      autoWidth:false,
      //pagingType: 'full_numbers',
      paging:true,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_ elementos',
        info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        },
        dom: 'Bfrtip',
        buttons: [
          'excel'
        ]
      }
    };

    this.dtOptions.pageLength=25;
    this.dtOptions.columns=this.makeColumns();
    this.dtOptions.columnDefs=this.getColumnRefs();
    this.dtOptions.rowCallback=this.getRowCallback;

    this.viewStatus = 1;
    this.getCatalogs();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next();
    this.getActive();
  }

  // EVENTS
  onAdd=()=> {
    let newModel = new CommissionPromoterAdditional();
    /*newModel.commission = 0;
    newModel.commissionMax = 0;
    newModel.collectCapitalAmountMin = 0;
    newModel.collectCapitalAmountMax = 0;*/
    this.openModalForm(newModel, 'create');
  }
  onEdit=(model:CommissionPromoterAdditional)=> {
    this.openModalForm(model, 'edit');
  }
  onDetail=(model:CommissionPromoterAdditional)=> {
    this.openModalForm(model, 'detail');
  }
  onDelete=(model:CommissionPromoterAdditional)=> {
    this.openModalForm(model, 'delete');
  }
  onToggleActive=(model:CommissionPromoterAdditional)=> {
    this.openModalForm(model, 'toggleActive');
  }

  // EVENTS
  onEmployeeJobChange=e=> {
    if(e.length > 0){
      this.selectedEmployeeJobs=e;
    } else {
      this.selectedEmployeeJobs=[];
    }
  };
  onDownload=()=>{
    if(this.selectedEmployeeJob.length > 0) {
      let request:any = {};
      this.commissionPromoterAdditionalService.download(request).subscribe(response => {
        this.downloadFile(response);
      });
    } else {
      this.toastr.error('Seleccione un puesto!');
    }
  }
  onSearch=()=> {
    if(this.selectedEmployeeJob.length > 0){
      this.rerender();
    } else {
      this.toastr.error('Seleccione un mes!');
    }
  }
  openModalForm=(model:CommissionPromoterAdditional, mode:string)=> {
    let modalRef=this.modalService.open(ModalCommissionPromoterAdditionalComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.commissionPromoter=model;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode=mode;
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        if(reason === "success"){
          this.getCatalogs();
        }
      }
    );
  }
  onActiveChange(e) {
    e.preventDefault();
    console.log(">> onActiveChange > e=", e.target.checked);
    let modalRef=this.modalService.open(ModalConfirmComponent, {centered:true, size:'sm', backdrop:'static', keyboard:false});
    modalRef.componentInstance.header="Desea " + (e.target.checked ? "activar" : "desactivar") + " las Comisiones?";
    modalRef.componentInstance.text="Se <b>" + (e.target.checked ? "activarán" : "desactivarán") + "</b> las comisiones dentro del cálculo diario! Está seguro de continuar?";
    modalRef.componentInstance.viewHeader = 0;
    modalRef.componentInstance.acceptText = "Sí, " + (e.target.checked ? "Activar" : "Desactivar") + "!";
    modalRef.componentInstance.cancelText = "Cancelar";
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        if(reason ==='accept') {
          this.toggleActive(!this.activeCommissions ? 1 : 0);
        }
      }
    );
  }

  // HELPERS
  rerender(): void {
    this.datatableElement.dtInstance.then((dtInstance) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  downloadFile(data: Blob) {
    const contentType = 'application/vnd.openxmlformats-ficedocument.spreadsheetml.sheet';

    const blob = new Blob([data], { type: contentType });
    const todayDate = new Date().toISOString().slice(0, 10);
    const fileName:string = 'CommissionPromoterAdjustment_' + todayDate + '.xlsx';

    const objectUrl:string = URL.createObjectURL(blob);
    const a:HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }
  makeColumns=()=> {
    this.columns = [{
      title:'Línea Negocio',
      data : 'businessProductDescr',
      className: 'text-center'
    },{
      title:'Tipo Fondeo',
      data : 'ownerTypeDescr',
      className: 'text-center'
    },{
      title:'Producto',
      data : 'productosCOEDescr',
      className: 'text-center'
    },{
      title:'Convenio',
      data : 'afiliateDescr',
      className: 'text-center'
    },{
      title:'Plazo',
      data : 'paymentDescr',
      className: 'text-center'
    },{
      title:'Puesto',
      data : 'employeeJobDescr',
      className: 'text-center'
    },{
      title:'Comisión',
      data:function(data) {
        return data.commission + '%'
      },
      className: 'text-center'
    },{
      title:'Comisión Máxima',
      data:function(data) {
        return data.commissionMax + '%'
      },
      className: 'text-center'
    },{
      title:'Monto Mínimo',
      data:function(data) {
        return'$' + data.collectCapitalAmountMin
      },
      className: 'text-center'
    },{
      title:'Monto Máximo',
      data:function(data) {
        return '$' + data.collectCapitalAmountMax
      },
      className: 'text-center'
    },{
      title:'Fecha',
      data:function(data) {
        return data.modifDate != null ? data.modifDate : data.createDate;
      },
      className: 'text-center'
    },{
      title:'Usuario',
      data:function(data) {
        return data.modifUserName != null ? data.modifUserName : data.createUserName;
      },
      className: 'text-center'
    },{
      title:'Estatus', data:function(data) {
        let active = data.activeId ? '<span class="badge badge-success">Activo <i class="icon-ok"></i></span>' : '<span class="badge badge-danger">Inactivo <i class="icon-cancel"></i></span>';
        return active;
      }, className:'text-center'
    },{
      title:'Acciones', data:function(data) {
        let menu='<div class="btn-group">\n' +
          '<span class="badge badge-info dropdown-toggle" data-toggle="dropdown" aria-expanded="false" role="button">Acciones</span>\n' +
          '<ul class="dropdown-menu">\n' +
          '  <li><a class="dropdown-item btn-detail clearfix"><i class="icon-eye"></i>&nbsp;&nbsp;Consultar</a></li>\n' +
          '  <li><a class="dropdown-item btn-edit"><i class="icon-pencil"></i>&nbsp;&nbsp;Editar</a></li>\n' +
          '  <li><a class="dropdown-item btn-delete"><i class="icon-trash"></i>&nbsp;&nbsp;Eliminar</a></li>\n' +
          '  <li><a class="dropdown-item btn-toggle-active"><i class="icon-toggle-on"></i>&nbsp;&nbsp;Activar/Desactivar</a></li>\n' +
          '</ul></div>';
        return menu;
      }, className:'text-center'
    }];
    return this.columns;
  }
  getColumnRefs=()=> {
    return [{ responsivePriority: 1, width:100, targets: -1 },
            { responsivePriority: 2, width:100, targets: -2 }];
  }
  getRowCallback=(row:Node, data:any[] | Object, index:number) => {
    let me = this;
    let btnEdit = $('td', row).find('a.btn-edit');
    let btnDetail = $('td', row).find('a.btn-detail');
    let btnDelete = $('td', row).find('a.btn-delete');
    let btnToggleActive = $('td', row).find('a.btn-toggle-active');

    $('td', row).unbind('dblclick');
    $('td', row).bind('dblclick', () => {
      me.onEdit(data as CommissionPromoterAdditional);
    });

    if (btnEdit) {
      btnEdit.unbind('click');
      btnEdit.bind('click', () => {
        me.onEdit(data as CommissionPromoterAdditional);
      });
    }
    if (btnDetail) {
      btnDetail.unbind('click');
      btnDetail.bind('click', () => {
        me.onDetail(data as CommissionPromoterAdditional);
      });
    }
    if (btnDelete) {
      btnDelete.unbind('click');
      btnDelete.bind('click', () => {
        me.onDelete(data as CommissionPromoterAdditional);
      });
    }
    if (btnToggleActive) {
      btnToggleActive.unbind('click');
      btnToggleActive.bind('click', () => {
        me.onToggleActive(data as CommissionPromoterAdditional);
      });
    }
    return row;
  }

  // INFO
  getActive=()=>{
      this.commissionPromoterAdditionalService.getActive()
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            console.log(">> getActive > RESP=", resp);
            this.activeCommissions=resp.data;
          }
        });
  }
  getCatalogs=()=> {
    this.loading = 1;
    forkJoin(
      this.commissionPromoterAdditionalService.getCommissions()
    )
      .pipe(
        tap(([resp]:[any])=> {
          this.errors = 0;
          console.log(">> resp=", resp);
          if(resp.codeHttpStatus == 200){
            if(resp.data != null && resp.data.length > 0) {
              this.listCommissionPromoterFiltered = resp.data;
              console.log(">> this.listItemsFiltered=", this.listCommissionPromoterFiltered);
            } else {
              this.listCommissionPromoterFiltered=[];
              this.toastr.info('No hay resultados búsqueda!');
            }
            this.datatableElement.dtInstance.then((dtInstance)=> {
              dtInstance.clear();
              dtInstance.rows.add(this.listCommissionPromoterFiltered).draw(false);
            });
          }else{
            this.toastr.error('Ha ocurrido un problema al ejecutar la consulta!');
            this.errors = this.errors + 1;
          }
          if(this.errors === 0){
            this.loading = 0;
          }
        }),
        catchError(err=> {
          console.log(">> catchError=", err);
          const error = err.error.message || err.error || err.message;
          return of(this.toastr.error(error));
        })
      )
      .subscribe();
  }
  toggleActive=(active:number)=>{
    this.loading = 1;
    this.commissionPromoterAdditionalService.toggleActive(active)
      .pipe(
        tap((resp:any)=> {
          console.log(">>> toggleActive >> response=", resp);
          if(resp.data != null && resp.codeHttpStatus === 200){
            console.log(">> getActive > RESP=", resp);
            this.activeCommissions=resp.data;
            this.toastr.success('Las comisiones se han guardado correctamente!');
            this.getCatalogs();
          }else{
            return of(this.toastr.error('Ocurrió un error al intentar guardar...'));
          }
        }),
        catchError(error=> {
          return of(this.toastr.error('Ocurrió un error al intentar guardar la comisión...'));
        })
      )
      .subscribe();
  }

}
